import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnswersService } from '../services/answers.service';
import { AuthService } from '../services/auth.service';
import { QuestionsService } from '../services/questions.service';

import { ConfirmdialogComponent } from '../confirmdialog/confirmdialog.component';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { UserupdateComponent } from '../userupdate/userupdate.component';
import { ResetpasswordComponent } from '../resetpassword/resetpassword.component';
import { ConfirmdeleteComponent } from '../confirmdelete/confirmdelete.component';

@Component({
  selector: 'app-userdash',
  templateUrl: './userdash.component.html',
  styleUrls: ['./userdash.component.css']
})
export class UserdashComponent implements OnInit {
  user: any;
  questions: any[]=[];
  answers: any[]=[];
  comments: any[]=[];
  errMess: Error;
  error : Boolean;
  constructor(private authService: AuthService, private questionService: QuestionsService,
     @Inject('imgbaseURL') private imgbaseURL, private answersService: AnswersService, private router: Router
     ,public dialog: MatDialog) { }

  ngOnInit() {
    //this.authService.loadUserCredentials();
    this.authService.getUserdetail()
      .subscribe(res => {
        if (res) {
          this.user = res;
          //console.log(this.user);
          this.getQuestionSet();
          this.getAnswerSet();
          this.getCommentSet();
          //console.log(this.user.question_set.length);
          //console.log(this.user.answer_set.length);
        }
      },
      error => {
        console.log(error);
        this.errMess = error;
        this.error = true;
      });
  }

  getQuestionSet(){
    this.questions = [];
    let i=0;
      while(i<this.user.question_set.length){
        this.questionService.getquestionbyID(this.user.question_set[i]).subscribe(
          res=>{
            if(res){
              this.questions.push(res);
              //console.log(this.questions);
            }
          },error=>{
            console.log(error);
            this.errMess = error;
            this.error = true;
          }
        )
        i=i+1;
      }
  }

  getAnswerSet(){
    this.answers = [];
    let i=0;
      while(i<this.user.answer_set.length){
        this.answersService.getanswersbyAns_ID(this.user.answer_set[i]).subscribe(
          res=>{
            if(res){
              this.answers.push(res);
              //console.log(this.answers);
            }
          },error=>{
            console.log(error);
            this.errMess = error;
            this.error = true;
          }
        )
        i=i+1;
      }
  }

  getCommentSet(){
    this.comments = [];
    console.log(this.user);
    let i=0;
      while(i<this.user.comment_set.length){
        this.answersService.getcommentsbycom_ID(this.user.comment_set[i]).subscribe(
          res=>{
            if(res){
              this.comments.push(res);
              //console.log(this.answers);
            }
          },error=>{
            console.log(error);
            this.errMess = error;
            this.error = true;
          }
        )
        i=i+1;
      }
  }

  deleteQuestion(ques_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {question: ques_id, type: "Question"};
    matConfig.disableClose = true;
    matConfig.height = "140px";
    matConfig.width = "250px";
    const loginRef = this.dialog.open(ConfirmdeleteComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
    
  }

  deleteAnswer(ans_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {answer: ans_id, type: "Answer"};
    matConfig.disableClose = true;
    matConfig.height = "140px";
    matConfig.width = "250px";
    const loginRef = this.dialog.open(ConfirmdeleteComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  deleteComment(com_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {comment: com_id, type: "Comment"};
    matConfig.disableClose = true;
    matConfig.height = "140px";
    matConfig.width = "250px";
    const loginRef = this.dialog.open(ConfirmdeleteComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  editQuestion(ques_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {question: ques_id, type: "Question"};
    matConfig.disableClose = true;
    matConfig.height = "210px";
    matConfig.width = "800px";
    const loginRef = this.dialog.open(ConfirmdialogComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  editAnswer(ans_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {answer: ans_id, type: "Answer"};
    matConfig.disableClose = true;
    matConfig.height = "210px";
    matConfig.width = "800px";
    const loginRef = this.dialog.open(ConfirmdialogComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  editComment(com_id){
    const matConfig = new MatDialogConfig();
    matConfig.data = {comment: com_id, type: "Comment"};
    matConfig.disableClose = true;
    matConfig.height = "210px";
    matConfig.width = "800px";
    const loginRef = this.dialog.open(ConfirmdialogComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  updateDetails(){
    const matConfig = new MatDialogConfig();
    matConfig.data = {};
    matConfig.disableClose = true;
    matConfig.height = "700px";
    matConfig.width = "600px";
    const loginRef = this.dialog.open(UserupdateComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }

  resetPassword(){
    const matConfig = new MatDialogConfig();
    matConfig.data = {};
    matConfig.disableClose = true;
    matConfig.height = "250px";
    matConfig.width = "600px";
    const loginRef = this.dialog.open(ResetpasswordComponent, matConfig);
    loginRef.afterClosed().subscribe(result=>{
      this.ngOnInit();
    });
  }
}
